// Slack's composer honours a text/html flavour, not typed markup, so a Slack copy writes HTML plus plain text.

/** Which flavours reached the clipboard. */
export type CopyResult = "rich" | "plain"

/** Throws only if the plain-text fallback fails too. */
export async function copyRichText(text: string, html: string): Promise<CopyResult> {
  const canWriteRich =
    typeof ClipboardItem !== "undefined" && typeof navigator?.clipboard?.write === "function"

  if (canWriteRich) {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([text], { type: "text/plain" }),
        }),
      ])
      return "rich"
    } catch {
      // Rich write refused; fall back to plain text.
    }
  }

  await navigator.clipboard.writeText(text)
  return "plain"
}
